import { render, staticRenderFns } from "./MenuInfoManage.vue?vue&type=template&id=b626dc0a&scoped=true"
import script from "./MenuInfoManage.vue?vue&type=script&lang=js"
export * from "./MenuInfoManage.vue?vue&type=script&lang=js"
import style0 from "../../style/large-screen-manage.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MenuInfoManage.vue?vue&type=style&index=1&id=b626dc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b626dc0a",
  null
  
)

export default component.exports